module.exports = __webpack_public_path__ + "static/media/mobile-store.ea055fa4.JPG";